import base from "@tastyworks/style-config/tailwind"

/** @type {import('tailwindcss').Config} */
export default {
  content: [
    "./src/**/*.{html,js,svelte,ts}",
    "./../../node_modules/@tastyworks/ui-library/src/**/*.{svelte,ts,js}",
  ],
  presets: [base],
  darkMode: "class",
  theme: {
    extend: {
      colors: {
        // TODO: remove these colors once the new colors are integrated into style-config
        "tasty-red": "#E21F26",
        footer: "#1D191B",
      },
    },
  },
  plugins: [],
}
